import { render, staticRenderFns } from "./CmpPage.vue?vue&type=template&id=dc57d808&scoped=true&"
import script from "./CmpPage.vue?vue&type=script&lang=js&"
export * from "./CmpPage.vue?vue&type=script&lang=js&"
import style0 from "./CmpPage.vue?vue&type=style&index=0&id=dc57d808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc57d808",
  null
  
)

export default component.exports